module.exports = __webpack_public_path__ + "img/ic_tiktok.17e0641d.png";